export const CheckMimeType = (event = {}) => {
  let files = event.target.files;
  let err = null;
  const mimeTypes = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword', 'application/pdf'];

  for(let x = 0; x < files.length; x++) {
    if (mimeTypes.every(type => files[x].type !== type)) {
      err = files[x].type+' is not a supported format\n';
    }
  }
  
  if (err !== null) {
    event.target.value = null
    console.log(err);
    return false;
  }
  return true;
};